// API module
import httpClient from '@emmacare/common/api/httpClient'

// constants
import { AUTH_FORGOT_PASSWORD, AUTH_LOGIN, AUTH_LOGOUT } from 'src/constants'

export default {
  getAuthTokens: (payload) => httpClient.post(AUTH_LOGIN, payload),
  refreshAuthTokens: (payload) => httpClient.post(AUTH_LOGIN, payload),
  logout: (payload = {}) => httpClient.post(AUTH_LOGOUT, payload),
  forgotPassword: (payload) => httpClient.post(AUTH_FORGOT_PASSWORD, payload)
}
